import type { MigrationManifest, PersistedState } from "redux-persist";

// Persisted-state migrations for the "glyde-preordering" key.
//
// Version 1 (FOYR-563, V2 "The Ticket"): the menu slice gained `menus` and
// `branding`. State persisted before then has neither; a returning guest
// mid-reservation would otherwise rehydrate a menu without them until the
// next refresh lands. The cart slice's shape is unchanged.
export const PERSIST_VERSION = 1;

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

type PersistedRoot = NonNullable<PersistedState> & { menu?: unknown };

export function migrateToV1(state: PersistedState): PersistedState {
  if (!state) return state;
  const root: PersistedRoot = state;
  const menu = root.menu;
  if (!isRecord(menu)) return state;
  const migrated: PersistedRoot = {
    ...root,
    menu: {
      ...menu,
      menus: Array.isArray(menu.menus) ? menu.menus : [],
      branding: isRecord(menu.branding) ? menu.branding : null,
    },
  };
  return migrated;
}

export const persistMigrations: MigrationManifest = {
  1: migrateToV1,
};
